import HideAndSeek from '../../tools/hide-and-seek';
import * as ACTIONTYPE from '../constants/actiontypes'
import {
  getActiveFrame,
} from '../selectors/selectors'


export const loadImages = (startIndex = 0, count = 2) => (dispatch, getState) => {
  let startIndex = 0;
  let count = 2;
  const state = getState();
  const activeFrame = getActiveFrame(state)
  const { jpg, encriptedImages } = state.book;

  if (activeFrame !== -1) {
    startIndex = activeFrame;
    count = 3;
  }

  for (let frameIndexToLoad = startIndex; frameIndexToLoad < startIndex + count; ++frameIndexToLoad) {

    if (jpg[frameIndexToLoad] && !(encriptedImages && encriptedImages[frameIndexToLoad])) {
      dispatch({
        type: ACTIONTYPE.ENCRYPTED_REQUEST_SENDED,
        imageIndex: frameIndexToLoad,
      })
      HideAndSeek({ url: jpg[frameIndexToLoad].download_link })
        .then((encodedImg) => {
          dispatch({
            type: ACTIONTYPE.ENCRYPTED_IMAGE_LOADED,
            imageIndex: frameIndexToLoad,
            encodedImg,
          });
        });
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/imagesLoad.js